import { StyledPageWrapper } from "@monorepo/components";

import { PageWrapper } from "components/Services/ServicesPage";

// TODO finish and use this component when backend is ready
const PrepaidElectricityService = () => {
  return (
    <StyledPageWrapper>
      <PageWrapper>PrepaidElectricityService</PageWrapper>
    </StyledPageWrapper>
  );
};

export default PrepaidElectricityService;
